export default __webpack_public_path__ + "static/media/expectmelogo.110ee061.svg";